/* eslint-disable max-len */
import React from 'react';
import SalesRow from './tableRow';
import NoSearchScreen from '../../CommonComponent/ListingScreens/NoSearchScreen';
import EmptyScreen from '../../CommonComponent/ListingScreens/EmptyScreen';
import TableHeader from '../../CommonComponent/ListingScreens/TableHeader';
import TableShimmer from '../../CommonComponent/ListingScreens/TableShimmer';

export default function ListingBody({ handleSort, currentSortColumn, handleOnClickPageNumber,searchParams,
    loading,sales, setLoader,salesInfo, id,saleLoading, onChangePaymentInfo, onSendPaymentReminder, onSendProccessPayment,
    isPaymentRequestEnabled, handleSendPaymentRequest}) {

    const orderListColumns = [
        { label: "", testId: "check", id: "check", minWidth: "50px", type: "checkbox" },
        { label: "Order no.", testId: "order_no", id: "order_no", minWidth: "130px" },
        { label: "Customer name", sortKey: "name", id: "customer_name", minWidth: "180px" },
        { label: "Auction name", sortKey: "auction_title", id: "auction_name", minWidth: "260px" },
        { label: "Date", testId: "created_at", id: "created_at", minWidth: "180px" },
        { label: "Result", testId: "order_amount", id: "order_amount", minWidth: "155px" },
        { label: "Payment type", testId: "payment", id: "payment", minWidth: "155px" },
        { label: "Payment status", testId: "payment_status", id: "payment_status", minWidth: "170px", center: true },
        { label: "", minWidth: "30px" },
        { label: "", minWidth: "50px" }
    ];

    return (
        <div className="pb-[120px] z-10 pt-2 overflow-auto">                
            <table aria-label="Outside Table" className="xl:w-full w-fit overflow-auto table-auto border-[#DEDEDE] 
                border rounded-lg" style={{borderCollapse: 'separate', borderSpacing: 0}}>
                <TableHeader columns={orderListColumns} handleSort={handleSort} currentSortColumn={currentSortColumn} />
                {(searchParams.get('keyword')!== null && sales?.length===0 && !loading ) && 
                    <NoSearchScreen searchValue={decodeURIComponent(searchParams.get('keyword'))} cols={8} />
                }
                {(searchParams.get('keyword')=== null && !loading && sales?.length===0) &&
                    <EmptyScreen message="No sales found" cols={8} />
                }
                {!loading?
                    <tbody>
                        {(sales?.length > 0 && !saleLoading) ? (
                            <SalesRow
                                onChangePaymentInfo={onChangePaymentInfo}
                                onSendPaymentReminder={onSendPaymentReminder}
                                onSendProccessPayment={onSendProccessPayment}
                                sales={sales} 
                                isPaymentRequestEnabled={isPaymentRequestEnabled}
                                handleSendPaymentRequest={handleSendPaymentRequest}
                            />
                        ) : (
                            <EmptyScreen message="No sales found" cols={8} />
                        )}
                    </tbody>
                    :<TableShimmer columns={orderListColumns} rowCount={5} />}
            </table>
        </div>
    );
}
